import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MaterialModule } from '@core/modules';
import { HelpModule } from '@features/main/help/help.module';
import { GuestUserRoutingModule } from './guest-user-routing.module';
import { GuestHomeComponent } from './guest-home/guest-home.component';
import { PolicyDetailsDialogComponent } from './policy-details-dialog/policy-details-dialog.component';
import { LogoComponent } from '@shared/components';
import { SetImagePathDirective } from '@shared/directives';

@NgModule({
  declarations: [
    GuestHomeComponent,
    PolicyDetailsDialogComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    GuestUserRoutingModule,
    HelpModule,
    LogoComponent,
    SetImagePathDirective
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class GuestUserModule { }
